export const bookWithMeDurationMinutes = "wfnnHc";
export const bookWithMeDurationOneHour = "NmAVs";
export const bookWithMeDurationHours = "QVb3Zc";
export const bookWithMeDurationOneHourAndMinutes = "n$UTle";
export const bookWithMeDurationHoursAndMinutes = "o1Je4";
export default {bookWithMeDurationMinutes,bookWithMeDurationOneHour,bookWithMeDurationHours,bookWithMeDurationOneHourAndMinutes,bookWithMeDurationHoursAndMinutes};